import { graphql, HttpResponse } from 'msw'
import { type EnrollmentCompanionIntroData, type EnrollmentCompanionIntroSubmitOutput } from '../../../models'

export const getEnrollmentCompanionIntroDataMock: EnrollmentCompanionIntroData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: 'enrollment/investments/brokerage/companion/intro',
  enrollmentData: {
    experimentId: 'BROKERAGE_COMPANION',
    investmentProfile: {
      account: {
        includeCompanionAccount: true,
      },
    },
  },
}

export const submitEnrollmentCompanionIntroDataMock: EnrollmentCompanionIntroSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: 'enrollment/investments/brokerage/companion/disclosures',
  enrollmentData: {
    experimentId: 'BROKERAGE_COMPANION',
    investmentProfile: {
      account: {
        includeCompanionAccount: true,
      },
    },
  },
}

export const mockGetEnrollmentCompanionIntroData = graphql.mutation('getEnrollmentCompanionIntroData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentCompanionIntroDataMock } })
})

export const mockSubmitEnrollmentCompanionIntroData = graphql.mutation('submitEnrollmentCompanionIntroData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentCompanionIntroDataMock } })
})

export const mockEnrollmentCompanionIntro = [
  mockGetEnrollmentCompanionIntroData,
  mockSubmitEnrollmentCompanionIntroData,
]
